import { DealerID } from "./Dealer";

export interface Domain {
  created_on: string;
  updated_on: string;
  name: string; // Name of the domain
  dealer_id: DealerID; // Dealer Identifier to which this domain belongs
  spam_action: string; // Mailgun reported SpamAction
  wildcard: boolean; // Wildcard is enabled
  state: string; // Current state of the domain
  sending_dns_records?: string[]; // Sending DNS Records
}
